import React from 'react';

interface ComingSoonOverlayProps {
  children: React.ReactNode;
  className?: string;
}

export const ComingSoonOverlay: React.FC<ComingSoonOverlayProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`coming-soon-container relative ${className}`}>
      <div 
        className="coming-soon-blur pointer-events-none opacity-75"
        style={{ filter: 'blur(2px)' }}
      >
        {children}
      </div>
      <div className="coming-soon-overlay absolute inset-0 flex items-center justify-center">
        <div className="bg-black/80 text-white px-4 py-2 rounded-lg font-semibold text-sm backdrop-blur-sm">
          Coming Soon
        </div>
      </div>
    </div>
  );
};

export default ComingSoonOverlay;
